import {Lang, PersonalityType} from '@context/CompetitionImamrezaContext';
import {useScopedTranslation} from '@hooks/useScopedTranslation';
import {getSafeLangImage} from '@utils';
import {loadLang} from '@utils/langStorage';
import React from 'react';
import arem1 from './assets/images/artist/arem-1.webp';
import arem2 from './assets/images/artist/arem-2.webp';
import arem3 from './assets/images/artist/arem-3.webp';

import arsk_ar_01 from './assets/images/artist/sk-ar-01.webp';
import arsk_ar_02 from './assets/images/artist/sk-ar-02.webp';
import arsk_ar_03 from './assets/images/artist/sk-ar-03.webp';
//--------------------------------
import arsk_en_01 from './assets/images/artist/sk-en-01.webp';
import arsk_en_02 from './assets/images/artist/sk-en-02.webp';
import arsk_en_03 from './assets/images/artist/sk-en-03.webp';

import arsk_fa_01 from './assets/images/artist/sk-fa-01.webp';
import arsk_fa_02 from './assets/images/artist/sk-fa-02.webp';
import arsk_fa_03 from './assets/images/artist/sk-fa-03.webp';
import inem1 from './assets/images/interaction/inem-1.webp';
import inem2 from './assets/images/interaction/inem-2.webp';
import inem3 from './assets/images/interaction/inem-3.webp';

import insk_ar_01 from './assets/images/interaction/sk-ar-01.webp';
import insk_ar_02 from './assets/images/interaction/sk-ar-02.webp';
import insk_ar_03 from './assets/images/interaction/sk-ar-03.webp';
//--------------------------------
import insk_en_01 from './assets/images/interaction/sk-en-01.webp';
import insk_en_02 from './assets/images/interaction/sk-en-02.webp';
import insk_en_03 from './assets/images/interaction/sk-en-03.webp';

import insk_fa_01 from './assets/images/interaction/sk-fa-01.webp';
import insk_fa_02 from './assets/images/interaction/sk-fa-02.webp';
import insk_fa_03 from './assets/images/interaction/sk-fa-03.webp';
import pcem1 from './assets/images/peaceful/pcem-1.webp';
import pcem2 from './assets/images/peaceful/pcem-2.webp';
import pcem3 from './assets/images/peaceful/pcem-3.webp';

import pcsk_ar_01 from './assets/images/peaceful/sk-ar-01.webp';
import pcsk_ar_02 from './assets/images/peaceful/sk-ar-02.webp';
import pcsk_ar_03 from './assets/images/peaceful/sk-ar-03.webp';
//--------------------------------
import pcsk_en_01 from './assets/images/peaceful/sk-en-01.webp';
import pcsk_en_02 from './assets/images/peaceful/sk-en-02.webp';
import pcsk_en_03 from './assets/images/peaceful/sk-en-03.webp';

import pcsk_fa_01 from './assets/images/peaceful/sk-fa-01.webp';
import pcsk_fa_02 from './assets/images/peaceful/sk-fa-02.webp';
import pcsk_fa_03 from './assets/images/peaceful/sk-fa-03.webp';

import srsk_ar_01 from './assets/images/searcher/sk-ar-01.webp';
import srsk_ar_02 from './assets/images/searcher/sk-ar-02.webp';
import srsk_ar_03 from './assets/images/searcher/sk-ar-03.webp';
//--------------------------------
import srsk_en_01 from './assets/images/searcher/sk-en-01.webp';
import srsk_en_02 from './assets/images/searcher/sk-en-02.webp';
import srsk_en_03 from './assets/images/searcher/sk-en-03.webp';

import srsk_fa_01 from './assets/images/searcher/sk-fa-01.webp';
import srsk_fa_02 from './assets/images/searcher/sk-fa-02.webp';
import srsk_fa_03 from './assets/images/searcher/sk-fa-03.webp';
import srem1 from './assets/images/searcher/srem-1.webp';
import srem2 from './assets/images/searcher/srem-2.webp';
import srem3 from './assets/images/searcher/srem-3.webp';

import svsk_ar_01 from './assets/images/servant/sk-ar-01.webp';
import svsk_ar_02 from './assets/images/servant/sk-ar-02.webp';
import svsk_ar_03 from './assets/images/servant/sk-ar-03.webp';
//--------------------------------
import svsk_en_01 from './assets/images/servant/sk-en-01.webp';
import svsk_en_02 from './assets/images/servant/sk-en-02.webp';
import svsk_en_03 from './assets/images/servant/sk-en-03.webp';

import svsk_fa_01 from './assets/images/servant/sk-fa-01.webp';
import svsk_fa_02 from './assets/images/servant/sk-fa-02.webp';
import svsk_fa_03 from './assets/images/servant/sk-fa-03.webp';
import svem1 from './assets/images/servant/svem-1.webp';
import svem2 from './assets/images/servant/svem-2.webp';
import svem3 from './assets/images/servant/svem-3.webp';
//--------------------------------
const arskImage01: Record<Lang, string> = {
	en: arsk_en_01,
	fa: arsk_fa_01,
	ar: arsk_ar_01
};
const arskImage02: Record<Lang, string> = {
	en: arsk_en_02,
	fa: arsk_fa_02,
	ar: arsk_ar_02
};
const arskImage03: Record<Lang, string> = {
	en: arsk_en_03,
	fa: arsk_fa_03,
	ar: arsk_ar_03
};
//--------------------------------
const inskImage01: Record<Lang, string> = {
	en: insk_en_01,
	fa: insk_fa_01,
	ar: insk_ar_01
};
const inskImage02: Record<Lang, string> = {
	en: insk_en_02,
	fa: insk_fa_02,
	ar: insk_ar_02
};
const inskImage03: Record<Lang, string> = {
	en: insk_en_03,
	fa: insk_fa_03,
	ar: insk_ar_03
};
//--------------------------------
const pcskImage01: Record<Lang, string> = {
	en: pcsk_en_01,
	fa: pcsk_fa_01,
	ar: pcsk_ar_01
};
const pcskImage02: Record<Lang, string> = {
	en: pcsk_en_02,
	fa: pcsk_fa_02,
	ar: pcsk_ar_02
};
const pcskImage03: Record<Lang, string> = {
	en: pcsk_en_03,
	fa: pcsk_fa_03,
	ar: pcsk_ar_03
};
//--------------------------------
const srskImage01: Record<Lang, string> = {
	en: srsk_en_01,
	fa: srsk_fa_01,
	ar: srsk_ar_01
};
const srskImage02: Record<Lang, string> = {
	en: srsk_en_02,
	fa: srsk_fa_02,
	ar: srsk_ar_02
};
const srskImage03: Record<Lang, string> = {
	en: srsk_en_03,
	fa: srsk_fa_03,
	ar: srsk_ar_03
};
//--------------------------------
const svskImage01: Record<Lang, string> = {
	en: svsk_en_01,
	fa: svsk_fa_01,
	ar: svsk_ar_01
};
const svskImage02: Record<Lang, string> = {
	en: svsk_en_02,
	fa: svsk_fa_02,
	ar: svsk_ar_02
};
const svskImage03: Record<Lang, string> = {
	en: svsk_en_03,
	fa: svsk_fa_03,
	ar: svsk_ar_03
};
//--------------------------------
export const SelfKnowledgeModeContent = ({type}: {type: PersonalityType}) => {
	const {t} = useScopedTranslation();
	const lang = loadLang();
	const contentMap: Record<PersonalityType, JSX.Element> = {
		peaceful:
			<div className={'w-full flex flex-col gap-y-10 font-aria word-spacing-tighter'}>
				<div className={'w-10/12 mx-auto flex flex-col gap-y-5'}>
					<div className={'flex flex-row justify-center items-center'}>
						{/*<div className={'w-40 text-orange-400 text-2xl font-heavy'}>{t('peacefulـpilgrim')}</div>*/}
						<img src={pcem1} alt={''} className={'w-3/12 h-fit'}/>
					</div>
					<div>
						<img src={getSafeLangImage(pcskImage01, lang)} alt={'peaceful'} className={'w-full h-fit'}/>
						{/*<div className={'text-white font-bold text-xl text-justify'}>{parse(t('selfKnowledge.peaceful.0'))}</div>*/}
					</div>
				</div>
				<div className={'w-10/12 mx-auto flex flex-col gap-y-5'}>
					<div className={'flex flex-row justify-center items-center'}>
						{/*<div className={'w-40 text-orange-400 text-2xl font-heavy'}>{t('you_look_like')}</div>*/}
						<img src={pcem2} alt={''} className={'w-3/12 h-fit'}/>
					</div>
					<div>
						<img src={getSafeLangImage(pcskImage02, lang)} alt={'peaceful'} className={'w-full h-fit'}/>
						{/*<div*/}
						{/*	className={'text-white font-bold text-xl text-justify'}>{parse(t('selfKnowledge.peaceful.1'))}</div>*/}
						{/*<div*/}
						{/*	className={'text-white font-bold text-xl text-justify'}>{parse(t('selfKnowledge.peaceful.2'))}</div>*/}
					</div>
				</div>
				<div className={'w-10/12 mx-auto flex flex-col gap-y-5'}>
					<div className={'flex flex-row justify-center items-center'}>
						{/*<div className={'w-40 text-orange-400 text-2xl font-heavy'}></div>*/}
						<img src={pcem3} alt={''} className={'w-3/12 h-fit'}/>
					</div>
					<div>
						
						<img src={getSafeLangImage(pcskImage03, lang)} alt={'peaceful'} className={'w-full h-fit'}/>
						{/*<div className={'text-white font-bold text-xl text-justify'}>{parse(t('selfKnowledge.peaceful.3'))}</div>*/}
					</div>
				</div>
			</div>,
		artist:
			<div className={'w-full flex flex-col gap-y-10 font-aria word-spacing-tighter'}>
				<div className={'w-10/12 mx-auto flex flex-col gap-y-5'}>
					<div className={'flex flex-row justify-center items-center'}>
						{/*<div className={'w-40 text-orange-400 text-2xl font-heavy'}>{t('peacefulـpilgrim')}</div>*/}
						<img src={arem1} alt={''} className={'w-3/12 h-fit'}/>
					</div>
					<div>
						<img src={getSafeLangImage(arskImage01, lang)} alt={'peaceful'} className={'w-full h-fit'}/>
						{/*<div className={'text-white font-bold text-xl text-justify'}>{parse(t('selfKnowledge.peaceful.0'))}</div>*/}
					</div>
				</div>
				<div className={'w-10/12 mx-auto flex flex-col gap-y-5'}>
					<div className={'flex flex-row justify-center items-center'}>
						{/*<div className={'w-40 text-orange-400 text-2xl font-heavy'}>{t('you_look_like')}</div>*/}
						<img src={arem2} alt={''} className={'w-3/12 h-fit'}/>
					</div>
					<div>
						<img src={getSafeLangImage(arskImage02, lang)} alt={'peaceful'} className={'w-full h-fit'}/>
						{/*<div*/}
						{/*	className={'text-white font-bold text-xl text-justify'}>{parse(t('selfKnowledge.peaceful.1'))}</div>*/}
						{/*<div*/}
						{/*	className={'text-white font-bold text-xl text-justify'}>{parse(t('selfKnowledge.peaceful.2'))}</div>*/}
					</div>
				</div>
				<div className={'w-10/12 mx-auto flex flex-col gap-y-5'}>
					<div className={'flex flex-row justify-center items-center'}>
						{/*<div className={'w-40 text-orange-400 text-2xl font-heavy'}></div>*/}
						<img src={arem3} alt={''} className={'w-3/12 h-fit'}/>
					</div>
					<div>
						<img src={getSafeLangImage(arskImage03, lang)} alt={'peaceful'} className={'w-full h-fit'}/>
						{/*<div className={'text-white font-bold text-xl text-justify'}>{parse(t('selfKnowledge.peaceful.3'))}</div>*/}
					</div>
				</div>
			</div>,
		interaction:
			<div className={'w-full flex flex-col gap-y-10 font-aria word-spacing-tighter'}>
				<div className={'w-10/12 mx-auto flex flex-col gap-y-5'}>
					<div className={'flex flex-row justify-center items-center'}>
						{/*<div className={'w-40 text-orange-400 text-2xl font-heavy'}>{t('peacefulـpilgrim')}</div>*/}
						<img src={inem1} alt={''} className={'w-3/12 h-fit'}/>
					</div>
					<div>
						<img src={getSafeLangImage(inskImage01, lang)} alt={'peaceful'} className={'w-full h-fit'}/>
						{/*<div className={'text-white font-bold text-xl text-justify'}>{parse(t('selfKnowledge.peaceful.0'))}</div>*/}
					</div>
				</div>
				<div className={'w-10/12 mx-auto flex flex-col gap-y-5'}>
					<div className={'flex flex-row justify-center items-center'}>
						{/*<div className={'w-40 text-orange-400 text-2xl font-heavy'}>{t('you_look_like')}</div>*/}
						<img src={inem2} alt={''} className={'w-3/12 h-fit'}/>
					</div>
					<div>
						<img src={getSafeLangImage(inskImage02, lang)} alt={'peaceful'} className={'w-full h-fit'}/>
						{/*<div*/}
						{/*	className={'text-white font-bold text-xl text-justify'}>{parse(t('selfKnowledge.peaceful.1'))}</div>*/}
						{/*<div*/}
						{/*	className={'text-white font-bold text-xl text-justify'}>{parse(t('selfKnowledge.peaceful.2'))}</div>*/}
					</div>
				</div>
				<div className={'w-10/12 mx-auto flex flex-col gap-y-5'}>
					<div className={'flex flex-row justify-center items-center'}>
						{/*<div className={'w-40 text-orange-400 text-2xl font-heavy'}></div>*/}
						<img src={inem3} alt={''} className={'w-3/12 h-fit'}/>
					</div>
					<div>
						
						<img src={getSafeLangImage(inskImage03, lang)} alt={'peaceful'} className={'w-full h-fit'}/>
						{/*<div className={'text-white font-bold text-xl text-justify'}>{parse(t('selfKnowledge.peaceful.3'))}</div>*/}
					</div>
				</div>
			</div>,
		servant:
			<div className={'w-full flex flex-col gap-y-10 font-aria word-spacing-tighter'}>
				<div className={'w-10/12 mx-auto flex flex-col gap-y-5'}>
					<div className={'flex flex-row justify-center items-center'}>
						{/*<div className={'w-40 text-orange-400 text-2xl font-heavy'}>{t('peacefulـpilgrim')}</div>*/}
						<img src={svem1} alt={''} className={'w-3/12 h-fit'}/>
					</div>
					<div>
						<img src={getSafeLangImage(svskImage01, lang)} alt={'peaceful'} className={'w-full h-fit'}/>
						{/*<div className={'text-white font-bold text-xl text-justify'}>{parse(t('selfKnowledge.peaceful.0'))}</div>*/}
					</div>
				</div>
				<div className={'w-10/12 mx-auto flex flex-col gap-y-5'}>
					<div className={'flex flex-row justify-center items-center'}>
						{/*<div className={'w-40 text-orange-400 text-2xl font-heavy'}>{t('you_look_like')}</div>*/}
						<img src={svem2} alt={''} className={'w-3/12 h-fit'}/>
					</div>
					<div>
						<img src={getSafeLangImage(svskImage02, lang)} alt={'peaceful'} className={'w-full h-fit'}/>
						{/*<div*/}
						{/*	className={'text-white font-bold text-xl text-justify'}>{parse(t('selfKnowledge.peaceful.1'))}</div>*/}
						{/*<div*/}
						{/*	className={'text-white font-bold text-xl text-justify'}>{parse(t('selfKnowledge.peaceful.2'))}</div>*/}
					</div>
				</div>
				<div className={'w-10/12 mx-auto flex flex-col gap-y-5'}>
					<div className={'flex flex-row justify-center items-center'}>
						{/*<div className={'w-40 text-orange-400 text-2xl font-heavy'}></div>*/}
						<img src={svem3} alt={''} className={'w-3/12 h-fit'}/>
					</div>
					<div>
						
						<img src={getSafeLangImage(svskImage03, lang)} alt={'peaceful'} className={'w-full h-fit'}/>
						{/*<div className={'text-white font-bold text-xl text-justify'}>{parse(t('selfKnowledge.peaceful.3'))}</div>*/}
					</div>
				</div>
			</div>,
		searcher:
			<div className={'w-full flex flex-col gap-y-10 font-aria word-spacing-tighter'}>
				<div className={'w-10/12 mx-auto flex flex-col gap-y-5'}>
					<div className={'flex flex-row justify-center items-center'}>
						{/*<div className={'w-40 text-orange-400 text-2xl font-heavy'}>{t('peacefulـpilgrim')}</div>*/}
						<img src={srem1} alt={''} className={'w-3/12 h-fit'}/>
					</div>
					<div>
						<img src={getSafeLangImage(srskImage01, lang)} alt={'peaceful'} className={'w-full h-fit'}/>
						{/*<div className={'text-white font-bold text-xl text-justify'}>{parse(t('selfKnowledge.peaceful.0'))}</div>*/}
					</div>
				</div>
				<div className={'w-10/12 mx-auto flex flex-col gap-y-5'}>
					<div className={'flex flex-row justify-center items-center'}>
						{/*<div className={'w-40 text-orange-400 text-2xl font-heavy'}>{t('you_look_like')}</div>*/}
						<img src={srem2} alt={''} className={'w-3/12 h-fit'}/>
					</div>
					<div>
						<img src={getSafeLangImage(srskImage02, lang)} alt={'peaceful'} className={'w-full h-fit'}/>
						{/*<div*/}
						{/*	className={'text-white font-bold text-xl text-justify'}>{parse(t('selfKnowledge.peaceful.1'))}</div>*/}
						{/*<div*/}
						{/*	className={'text-white font-bold text-xl text-justify'}>{parse(t('selfKnowledge.peaceful.2'))}</div>*/}
					</div>
				</div>
				<div className={'w-10/12 mx-auto flex flex-col gap-y-5'}>
					<div className={'flex flex-row justify-center items-center'}>
						{/*<div className={'w-40 text-orange-400 text-2xl font-heavy'}></div>*/}
						<img src={srem3} alt={''} className={'w-3/12 h-fit'}/>
					</div>
					<div>
						
						<img src={getSafeLangImage(srskImage03, lang)} alt={'peaceful'} className={'w-full h-fit'}/>
						{/*<div className={'text-white font-bold text-xl text-justify'}>{parse(t('selfKnowledge.peaceful.3'))}</div>*/}
					</div>
				</div>
			</div>
	};
	return contentMap[type] || <div>No content</div>;
};
